import React from "react";
import "../App.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const Page5 = (rond) => {
  const navigate = useNavigate();
  const location = useLocation();
  const allResults = location.state.allResults;
  let { round } = rond;
  round = round - 1;
  let roundc = round/4 ;

  return (
    <>
      <div className="input-container">
        <div className="flex flex-col items-center">
          <div>
            <h1 className="text-3xl pt-8">Experiment 4 : AES Key Generation</h1>
          </div>
          <div className="pt-10">
            <h1>Hex Value: {allResults[4]}</h1>
            <br />
          </div>

          <div className="flex flex-col">
            <table className="border-separate border-spacing-2 border border-slate-500 ...">
                <tr>
                    <th colSpan={4}>Sub Key - {round/4 }</th>
                    <th colSpan={4}>Sub Key - {round/4 +1}</th>

                </tr>
              <tr>
                <th className=" bg-red-400">w{round}</th>
                <th className=" bg-red-400">w{round+1}</th>
                <th className=" bg-red-400">w{round+2}</th>
                <th className=" bg-red-400">w{round+3}</th>
                <th className=" bg-green-400">w{round+4}</th>
                <th className=" bg-green-400">w{round+5}</th>
                <th className=" bg-green-400">w{round+6}</th>
                <th className=" bg-green-400">w{round+7}</th>
                <th>...</th>
                <th>...</th>
                <th>w43</th>
              </tr>

              <tr>
                <td>{allResults[3][round][0]}</td>
                <td>{allResults[3][round+1][0]}</td>
                <td>{allResults[3][round+2][0]}</td>
                <td>{allResults[3][round+3][0]}</td>
                <td className=" font-bold">{allResults[3][round+4][0]}</td>
                <td className=" font-bold">{allResults[3][round+5][0]}</td>
                <td className=" font-bold">{allResults[3][round+6][0]}</td>
                <td className=" font-bold">{allResults[3][round+7][0]}</td>
              </tr>
              <tr>
              <td>{allResults[3][round][1]}</td>
                <td>{allResults[3][round+1][1]}</td>
                <td>{allResults[3][round+2][1]}</td>
                <td>{allResults[3][round+3][1]}</td>
                <td className=" font-bold">{allResults[3][round+4][1]}</td>
                <td className=" font-bold">{allResults[3][round+5][1]}</td>
                <td className=" font-bold">{allResults[3][round+6][1]}</td>
                <td className=" font-bold">{allResults[3][round+7][1]}</td>
              </tr>
              <tr>
              <td>{allResults[3][round][2]}</td>
                <td>{allResults[3][round+1][2]}</td>
                <td>{allResults[3][round+2][2]}</td>
                <td>{allResults[3][round+3][2]}</td>
                <td className=" font-bold">{allResults[3][round+4][2]}</td>
                <td className=" font-bold">{allResults[3][round+5][2]}</td>
                <td className=" font-bold">{allResults[3][round+6][2]}</td>
                <td className=" font-bold">{allResults[3][round+7][2]}</td>
              </tr>
              <tr>
              <td>{allResults[3][round][3]}</td>
                <td>{allResults[3][round+1][3]}</td>
                <td>{allResults[3][round+2][3]}</td>
                <td>{allResults[3][round+3][3]}</td>
                <td className=" font-bold">{allResults[3][round+4][3]}</td>
                <td className=" font-bold">{allResults[3][round+5][3]}</td>
                <td className=" font-bold">{allResults[3][round+6][3]}</td>
                <td className=" font-bold">{allResults[3][round+7][3]}</td>
              </tr>
            </table>
            <h2 className="text-xl mt-3 bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out">
              {" "}
              w{round+4} = w{round} xor g(w{round+3})
            </h2>
          </div>
          <div className="grid grid-cols-3 gap-8 pt-5">
            <div className="text-lg">
              <div className=" bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out leading-8">
                w{round+4} = {allResults[3][round][0]} {allResults[3][round][1]} {allResults[3][round][2]} {allResults[3][round][3]} ⊕ {allResults[2][roundc][0]} {allResults[2][roundc][1]}{" "}
                {allResults[2][roundc][2]} {allResults[2][roundc][3]}
                <br />
                w{round+4} = {allResults[3][round+4][0]} {allResults[3][round+4][1]} {allResults[3][round+4][2]} {allResults[3][round+4][3]}
              </div>
            </div>

            <div className="text-lg">
              <div className=" bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out leading-8">
                w{round+5} = w{round+1} ⊕ w{round+4}
                <br />
                w{round+6} = w{round+2} ⊕ w{round+5}
                <br />
                w{round+7} = w{round+3} ⊕ w{round+6}
              </div>
            </div>

            <div className="text-lg">
              <div className=" bg-emerald-100 p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out leading-8">
                w{round+5} = {allResults[3][round+1][0]} {allResults[3][round+1][1]} {allResults[3][round+1][2]} {allResults[3][round+1][3]} ⊕ {allResults[3][round+4][0]} {allResults[3][round+4][1]} {allResults[3][round+4][2]}{" "}
                {allResults[3][round+4][3]}
                <br />
                w{round+5} = {allResults[3][round+5][0]} {allResults[3][round+5][1]} {allResults[3][round+5][2]} {allResults[3][round+5][3]}
                <br />
                w{round+6} = {allResults[3][round+2][0]} {allResults[3][round+2][1]} {allResults[3][round+2][2]} {allResults[3][round+2][3]} ⊕ {allResults[3][round+5][0]} {allResults[3][round+5][1]} {allResults[3][round+5][2]}{" "}
                {allResults[3][round+5][3]}
                <br />
                w{round+6} = {allResults[3][round+6][0]} {allResults[3][round+6][1]} {allResults[3][round+6][2]} {allResults[3][round+6][3]}
                <br />
                w{round+7} = {allResults[3][round+3][0]} {allResults[3][round+3][1]} {allResults[3][round+3][2]} {allResults[3][round+3][3]} ⊕ {allResults[3][round+6][0]} {allResults[3][round+6][1]} {allResults[3][round+6][2]}{" "}
                {allResults[3][round+6][3]}
                <br />
              </div>
            </div>

          </div>

        </div>
      </div>
    </>
  );
};

export default Page5;
